export default __webpack_public_path__ + "static/media/metaltilefloor.d4c2852d.png";